import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c518821"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_ttn_timer = _resolveComponent("ttn-timer")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
      ], 64))
    : (_ctx.column.key === 'ttnNumber')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          class: "TtnsLink",
          to: `/tms/ttns/${_ctx.row.id}`,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.ttnNumber), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.column.key === 'tripNumber')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: "TtnsLink",
            to: `/tms/trips/${_ctx.row.tripId}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.row.tripNumber), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_ctx.column.key === 'expectedDate')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.expectedDate)), 1)
            ], 64))
          : (_ctx.column.key === 'arrivalDate')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.arrivalDate)), 1)
              ], 64))
            : (_ctx.column.key === 'comment' && _ctx.row.comment)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  _createTextVNode(_toDisplayString(_ctx.row.comment.name), 1)
                ], 64))
              : (_ctx.column.key === 'transportType' && _ctx.row.transportType)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createTextVNode(_toDisplayString(_ctx.row.transportType.name), 1)
                  ], 64))
                : (_ctx.isDirection)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createTextVNode(_toDisplayString(_ctx.row.fromCity.name) + " - " + _toDisplayString(_ctx.row.toCity.name), 1)
                    ], 64))
                  : (_ctx.column.key === 'status')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        (_ctx.row.status)
                          ? (_openBlock(), _createBlock(_component_cheap, {
                              key: 0,
                              class: _normalizeClass(_ctx.getCheapClass)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getCheapTitle), 1)
                              ]),
                              _: 1
                            }, 8, ["class"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_1, " - "))
                      ], 64))
                    : (_ctx.column.key === 'timer')
                      ? (_openBlock(), _createBlock(_component_ttn_timer, {
                          key: 9,
                          "status-id": _ctx.row.status.id,
                          dates: _ctx.row.dates,
                          "delayed-time": _ctx.row.delayedTime
                        }, null, 8, ["status-id", "dates", "delayed-time"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                          _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
                        ], 64))
}